import React from 'react';
import './Skeleton.css';

export const Skeleton = ({ width, height, borderRadius = 4, className = '' }) => {
  const style = {
    width: width || '100%',
    height: height || 14,
    borderRadius,
  };
  return <div className={`skeleton ${className}`} style={style} />;
};

export const SkeletonAvatar = ({ size = 44, className = '' }) => {
  return (
    <div
      className={`skeleton-avatar ${className}`}
      style={{ width: size, height: size }}
    />
  );
};

export const SkeletonText = ({ lines = 3, className = '' }) => {
  return (
    <div className={`skeleton-text ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          height={14}
          width={i === lines - 1 ? '60%' : '100%'}
          className="skeleton-text-line"
        />
      ))}
    </div>
  );
};

export const CardSkeleton = ({ className = '' }) => {
  return (
    <div className={`card-skeleton ${className}`}>
      <div className="skeleton-card-header">
        <SkeletonAvatar size={44} />
        <div className="skeleton-user-info">
          <Skeleton width={140} height={14} />
          <Skeleton width={80} height={12} className="skeleton-time" />
        </div>
      </div>
      <div className="skeleton-card-content">
        <Skeleton lines={3} />
      </div>
      <div className="skeleton-card-footer">
        <Skeleton width={60} height={32} borderRadius={16} />
        <Skeleton width={60} height={32} borderRadius={16} />
        <Skeleton width={60} height={32} borderRadius={16} />
      </div>
    </div>
  );
};

export const PostSkeleton = ({ className = '' }) => {
  return (
    <div className={`post-skeleton ${className}`}>
      <div className="skeleton-post-header">
        <SkeletonAvatar size={48} />
        <div className="skeleton-post-user">
          <Skeleton width={120} height={14} />
          <Skeleton width={80} height={12} />
        </div>
      </div>
      <div className="skeleton-post-content">
        <Skeleton lines={3} />
      </div>
      <div className="skeleton-post-media">
        <Skeleton height={200} borderRadius={8} />
      </div>
      <div className="skeleton-post-actions">
        <Skeleton width={70} height={32} borderRadius={16} />
        <Skeleton width={70} height={32} borderRadius={16} />
        <Skeleton width={70} height={32} borderRadius={16} />
      </div>
    </div>
  );
};

export const ListSkeleton = ({ count = 5, className = '', itemHeight = 72 }) => {
  return (
    <div className={`list-skeleton ${className}`}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-list-item" style={{ height: itemHeight }}>
          <SkeletonAvatar size={48} />
          <div className="skeleton-list-item-content">
            <Skeleton width="60%" height={14} />
            <Skeleton width="40%" height={12} />
          </div>
        </div>
      ))}
    </div>
  );
};

export const ProfileSkeleton = ({ className = '' }) => {
  return (
    <div className={`profile-skeleton ${className}`}>
      <div className="skeleton-profile-header">
        <Skeleton height={200} borderRadius={0} className="skeleton-cover" />
        <div className="skeleton-profile-info">
          <SkeletonAvatar size={120} className="skeleton-profile-avatar" />
          <Skeleton width={200} height={24} className="skeleton-profile-name" />
          <Skeleton width={150} height={16} />
          <Skeleton width={300} height={14} />
        </div>
      </div>
      <div className="skeleton-profile-tabs">
        <Skeleton width={100} height={40} borderRadius={8} />
        <Skeleton width={100} height={40} borderRadius={8} />
        <Skeleton width={100} height={40} borderRadius={8} />
      </div>
      <div className="skeleton-profile-posts">
        <PostSkeleton />
        <PostSkeleton />
      </div>
    </div>
  );
};

export const PageSkeleton = ({ type = 'feed', count = 5, className = '' }) => {
  switch (type) {
    case 'feed':
      return (
        <div className={`page-skeleton ${className}`}>
          <div className="skeleton-page-header">
            <Skeleton width={200} height={32} />
          </div>
          <div className="skeleton-page-form">
            <SkeletonAvatar size={48} />
            <Skeleton width="70%" height={40} borderRadius={20} />
          </div>
          {Array.from({ length: count }).map((_, i) => (
            <PostSkeleton key={i} />
          ))}
        </div>
      );
    case 'list':
      return <ListSkeleton count={count} className={className} />;
    case 'profile':
      return <ProfileSkeleton className={className} />;
    case 'card':
      return (
        <div className={`page-skeleton ${className}`}>
          {Array.from({ length: count }).map((_, i) => (
            <CardSkeleton key={i} />
          ))}
        </div>
      );
    default:
      return <ListSkeleton count={count} className={className} />;
  }
};
